import React, {useState, useRef, useEffect} from 'react'
import DaySlider from './DaySlider';
import './Styles.css';


// import ImgCompass from './Images/ImgCompass.png';
// import ImgBindi from './Images/ImgBindi.png';
import ImgMap from './Images/map-zoom-trip.png';
import Van1 from './Images/van1.jpg';
import Van2 from './Images/van2.jpg';
import Van3 from './Images/van3.jpg';
import Climate1 from  './Images/climate1.png';
import DelhiFlight1 from './Images/delhi-flight-1.jpeg';
import DelhiFlight2 from './Images/delhi-flight-2.jpeg';
import DelhiAirport1 from './Images/delhi-airport-1.jpg';
import JamaMasjidDelhi from './Images/jama-masjid-delhi-night.jpg';
import ChandniChowk from './Images/chandni-chowk.jpg';
import TajMahal from './Images/taj-mahal.jpg';
import AgraFort from './Images/agra-fort.jpg';
import FatehpurSikri from './Images/fatehpur-sikri.webp';
import Jaipur1 from './Images/jaipur-hawa-mahal.jpg';
import Jaipur2 from './Images/jaipur-amber-fort.jpg';
import Pushkar1 from './Images/pushkar-lake-1.jpg';
import Pushkar2 from './Images/pushkar-lake-2.webp';
import Pushkar3 from './Images/pushkar-lake-3.jpg';
import MehrangarhFort from './Images/jodhpur-mehrangarh-fort.jpg';
import JaswantThada from './Images/jaswant-thada.jpg';
import JodhpurOldCity from './Images/jodhpur-old-city.jpg';
import Udaipur1 from './Images/ranakpur-temple.jpg';
import Udaipur2 from './Images/udaipur-city-palace.jpg';
import Udaipur3 from './Images/udaipur-lake-pichola.jpg';
import Udaipur4 from './Images/udaipur-jag-mandir-palace.jpg';
import Udaipur5 from './Images/udaipur-dudh-talai-lake.jpg';




function TimelessIndia() {

     const [showIndex, setShowIndex] = useState(false);
     const indexRef = useRef(null);
     const btnRef = useRef(null);


     useEffect(() => {
      const handleScroll = () => {
      if (showIndex) setShowIndex(false);
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [showIndex]);


     

  const toggleIndex = () => {
    setShowIndex(prev => !prev);
  };

  const scrollToSection = (id) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({
        behavior: "smooth",
        block: "start"
      });
    }

    setShowIndex(false);

  };



  return (

    <>

           
           
           
            <div className='BannerTimelessIndia'> 

            <div className="HeadTop">  Timeless India: A Journey through History, Heritage & Diwali Lights </div>
            {/* <p className='AboutPgSubH'> since 2014</p> */}
            {/* <p className='AboutPgSubH width-mission '>  Our mission is to curate socially responsible, joyful holidays with authentic, bespoke local travel experiences. We aim to continuously inspire discerning travellers and be among India’s trusted sustainable travel company. </p> */}
        
            </div>

            <div className='master-itinerary-cont'>

                   <div className='btn' onClick={ () => setShowIndex(prev => !prev) } ref={btnRef} >
                                {showIndex ? '×' : 'Menu'}
                   </div>
                



                    <div className={`index-contents ${showIndex ? 'show' : ''}`} ref={indexRef}>

                    <p className='content-item-head' >
                        Overview
                    </p>

                     <hr style={{ border: 'none', height: '1px', backgroundColor: '#e0e0e0', margin: '20px 0', }} />

                     <p className='content-item' onClick={() => scrollToSection("why-choose")}>
                        Why choose this Tour?
                    </p>

                    <p className='content-item' onClick={() => scrollToSection("sketch-map")}>
                        Sketch Itinerary & Map
                    </p>

                    <p className='content-item' onClick={() => scrollToSection("responsible")}>
                        Responsible & Sustainable Travel Highlights
                    </p>

                    <p className='content-item' onClick={() => scrollToSection("detailed-itinerary")}>
                        Detailed Itinerary
                    </p>

                    <p className='content-item' onClick={() => scrollToSection("important")}>
                        Its Important to know that
                    </p>

                     <p className='content-item' onClick={() => scrollToSection("visa")}>
                        Visa Formalities
                    </p>

                    <p className='content-item' onClick={() => scrollToSection("hotels")}>
                        Hotels
                    </p>                   

                    <p className='content-item' onClick={() => scrollToSection("rates")}>
                        Rates
                    </p>

                    <p className='content-item' onClick={() => scrollToSection("payment")}>
                        Payment & Cancellation Policy
                    </p>

                    {/* <p className='content-item' onClick={() => scrollToSection("get-involved")}>
                        Get involved
                    </p> */}

                    <p className='content-item' onClick={() => scrollToSection("transport")}>
                        Transport
                    </p>

                    <p className='content-item' onClick={() => scrollToSection("climate")}>
                        Climate
                    </p>

                    </div>


         <div className='content-right-col'> 

              <br/>
            <br/>

            <div className='' id="why-choose">

                <p className='  content-head '> Why Choose this Tour?</p>
                <p className=''> 
                    • This thoughtfully curated journey through North India blends history, culture, nature, craftsmanship, and authentic local encounters. Begin in Delhi, where ancient monuments, bustling bazaars, and Mughal-era architecture reveal the capital’s layered past. Continue to Agra to witness the timeless beauty of the Taj Mahal and the majestic Agra Fort, before traveling through the abandoned Mughal city of Fatehpur Sikri.

                   <br/>  • From there, immerse yourself in the vibrant heritage of Jaipur, the Pink City, discovering grand palaces, observatories, artisan workshops, traditional block printing, women-driven rickshaw tours, and a heartfelt Diwali celebration with a local family. Travel onward to Jodhpur, the Blue City, where Mehrangarh Fort, bustling markets, a Bollywood dance lesson, and a meaningful visit to a women’s empowerment NGO offer a deep connection to local life.

                   <br/>  • Your journey continues through the serene marble temples of Ranakpur before arriving in romantic Udaipur, the City of Lakes, known for its shimmering palaces, Mughal–Rajput architecture, exquisite miniature art, and a peaceful boat ride on Lake Pichola. The tour concludes with a return to Delhi for a relaxed finale before your onward flight home.

                   <br/>  • Rich in culture, heritage, craft traditions, and community experiences, this itinerary offers an inspiring and immersive exploration of India’s most captivating destinations.

            </p>

                
            </div>

            <br/>

            <div className=' sketch-itinerary-map' id="sketch-map"> 
                    <br/>
                    <p className=' content-head'> Sketch Itinerary & Map </p>
                    Day 1 : Flight to Delhi – 2 Nov 2026<br/>
                    Day 2 : Arrive Delhi (room available from 14h00 onwards of this day) – 3 Nov 2026<br/>
                    Day 3 : Delhi / Agra – 4 Nov 2026 <br/>
                    Day 4 : Agra – 5 Nov 2026 <br/> 
                    Day 5 : Agra / Jaipur – 6 Nov 2026 <br/>
                    Day 6 : Jaipur – 7 Nov 2026<br/>
                    Day 7 : Jaipur – 8 Nov 2026 (festival of Diwali)<br/>
                    Day 8 : Jaipur / Jodhpur – 9 Nov 2026 <br/>
                    Day 9 : Jodhpur – 10 Nov 2026<br/>
                    Day 10 : Jodhpur / Ranakpur / Udaipur – 11 Nov 2026<br/>
                    Day 11 : Udaipur – 12 Nov 2026<br/>
                    Day 12 : Departure transfer to Udaipur airport - 13 Nov 2026 
                    <br/> (We can book your flight to Delhi or other destinations within India at extra cost) – (no accommodation, transfers or any services in Delhi or other destinations after Udaipur)


            </div>

            
            
            <br/>
            {/* <div className=''> Click to Zoom Map </div> */}
            <br/>

            <div className='map-iti'> 

                <img  src={ImgMap} alt='Itinerary Map' />


            </div>

            <br/> <br/> 
          

            <div className='' id="responsible">

                <p className=' content-head'> Responsible & Sustainable Travel Highlights </p>
                <p className=''> 

                    <p className=' content-head'> 1. Environmental Responsibility </p>
                    • Eco-conscious transport choices such as electric battery carts at Amber Fort and cycle rickshaws in Old & Pink City reduce emissions and help keep heritage zones cleaner. <br/>
                    • Encourages low-waste travel through  use of a reusable tote bag instead of disposable plastic. <br/>
                    
                    <p className=' content-head'> 2. Socio-Cultural Responsibility </p>
                    <p> 
                       • Visits to historic monuments, ancient temples, and traditional craft studios promote respect for India’s diverse religious and cultural heritage. <br/>
                        • Hands-on experiences—like block printing, Bollywood dance, and Diwali celebrations with a local family—offer authentic cultural exchange while reinforcing appreciation for local traditions. <br/>
                        • Temples and sacred sites are visited respectfully, with guidance on modest dress and appropriate behavior. <br/>
                    </p>                            
                    <p className=' content-head'> 3. Economic Responsibility </p>

                    <p> 
                        The itinerary supports local economies through: <br/>
                        • Artisan-led workshops (block printing, miniature painting) <br/>
                        • Women-led initiatives like Pink City Rickshaw Company <br/>
                        • Visits to local markets, boutiques, and traditional craft hubs <br/>
                        When dining in community settings (Sambhali Trust, local restaurants, family homes), the economic benefit directly supports local families and grassroots organisations.
                    <p className=' content-head'>  4. Community Well-Being </p>
                    <p> 
                        • Your visit to the Sambhali Trust in Jodhpur directly contributes to programs empowering women, girls, and gender minorities through vocational training and education. <br/>
                        • Ethical interaction with elephants at Dera Amer, where rescued animals are cared for respectfully, supports welfare-focused animal management. <br/>
                        • Community-based tourism ensures income flows to rural families and self-organized social enterprises. <br/>
                    </p>
                    <p className=' content-head'> 5. Visitor Responsibility </p>
                    <p> 
                    Guests are encouraged to: <br/>
                    • Carry a reusable tote bag for shopping <br/>
                    • Minimize waste, and avoid single-use plastics <br/>
                    • Dress modestly at temples and participate mindfully in sacred or cultural spaces <br/>
                    </p>

                    <p> Photography guidelines at temples, and private homes help maintain dignity and privacy of local people. </p>

                </p>
            </p>

                
            </div>

            <br/> <br/>


             <div className='' id="detailed-itinerary" >

                        <hr style={{ border: 'none', height: '1px', backgroundColor: '#e0e0e0', margin: '20px 0', }} />


                <p className=' content-head'> Detailed Itinerary</p>
                



                <hr style={{ border: 'none', height: '1px', backgroundColor: '#e0e0e0', margin: '20px 0', }} />


                {/* <div> 

                    <p className=" iti-head"> Day 01 : Flight to Delhi</p>
                    <div className='text-slide'> <p> • Overnight on board flight.</p> </div>
                    <div className="image-sliders">   </div>

                </div> */}


                    <DaySlider
                        dayTitle="Day 01 : Flight to Delhi"
                        text={
                            <>
                           
                            <p>• Overnight on board flight.</p>
                            </>
                        }
                        images={[  
                           
                            // DelhiFlight1

                            ]}
                        />


                <hr className="mobile desktop" style={{ border: 'none', height: '1px', backgroundColor: '#e0e0e0', margin: '20px 0', }} />


                 

                   <DaySlider
                        dayTitle="Day 02 : Arrive Delhi"
                        text={
                            <>
                             <p> • Arrive Delhi <br/>

                            <hr style={{ border: 'none', height: '1px', backgroundColor: '#e0e0e0', margin: '20px 0', }} />


                                • Meet your India representative at the airport, transfer to the hotel (rooms available for check-in from 14h00 of this day) <br/>
                            
                                • Incase, arrival in Delhi is happening late night of Day 1 or early morning on Day 2, for immediate check-in at your group hotel, additional night in Delhi is required. Let us know if needed, we will quote you the supplement <br/>

                                • Depending upon your arrival time in Delhi, you may relax at the hotel or may proceed to explore Delhi on your own <br/>

                                • Overnight at hotel (no meals). <br/>

                            </p>
                            </>
                        }
                        images={[  
                             DelhiAirport1,  
                            // DelhiFlight1

                            ]}
                        />

               
                 <br/>

                <hr className="mobile desktop" style={{ border: 'none', height: '1px', backgroundColor: '#e0e0e0', margin: '20px 0', }} />

                
                  <DaySlider
                        dayTitle="Day 03 : Delhi - Agra "
                        text={
                            <>
                                 <p> 
                                    • 4h30 drive by road <br/>
                                    • Jama Masjid <br/>
                                    • Rickshaw ride tour in Chandi Chowk <br/>


                                    <hr style={{ border: 'none', height: '1px', backgroundColor: '#e0e0e0', margin: '20px 0', }} />
                                    • Breakfast at hotel <br/>
                                    • Meet your English speaking accompanying guide at the hotel. He will stay with you for the entire duration of the tour (till Udaipur) <br/>
                                    
                                    • Start your day with a visit to Old Delhi’s grand Friday Mosque (Jama Masjid), Shah Jahan’s final masterpiece (1644–1658), built in marble and red sandstone and elevated 10m above the bustling streets. Dress modestly and remove shoes. Explore the vibrant lanes of Old Delhi by cycle rickshaw, slipping through alleys cars can’t reach. <br/>

                                    • Lunch during sightseeing (included in our cost). <br/>
                                    • Afternoon drive to Agra, once a flourishing Mughal capital, where history, architecture, and culture await to be discovered. <br/>
                                    • Arrive and check-in at the hotel. <br/>
                                    • Dinner and overnight stay at Agra.

                                  </p>
                            </>
                        }
                        images={[  
                            JamaMasjidDelhi,  
                            ChandniChowk,

                            ]}
                        />

               

                 <br/>
                        
              <hr className="mobile desktop" style={{ border: 'none', height: '1px', backgroundColor: '#e0e0e0', margin: '20px 0', }} />


                 <DaySlider
                        dayTitle="Day 04 : Agra"
                        text={
                            <>
                                  <p> 
                    
                                        • Taj Mahal, UNESCO World Heritage site <br/>
                                        • Agra Fort, UNESCO World Heritage site <br/>

                                        <hr style={{ border: 'none', height: '1px', backgroundColor: '#e0e0e0', margin: '20px 0', }} />


                                        • Early breakfast at hotel <br/>
                                        • Begin the day with a visit to the Taj Mahal, the iconic mausoleum commissioned in 1632 by Emperor Shah Jahan in memory of his beloved wife. Built over 20 years on the southern bank of the Yamuna River, the Taj Mahal is a masterpiece of Mughal architecture, blending Indian, Persian, and Islamic influences. Its central structure, crafted from shimmering white marble, appears to change color with the shifting daylight, creating an ethereal beauty.  <br/>
                                        • Designated a UNESCO World Heritage site in 1983, it stands as one of the world’s most celebrated monuments and a timeless symbol of love, history, and artistic brilliance. <br/>                      
                                        • Return back to hotel for lunch (lunch on direct payment) <br/>
                                        • Later, explore Agra Fort, also known as the Red Fort, a vast 16th-century fortress of red sandstone overlooking the Yamuna River. Established by Emperor Akbar, the fort served both as a military base and a royal residence, housing the seat of government when Agra was the Mughal capital. Its impressive walls, palaces, and audience halls reflect the grandeur and strategic genius of the Mughal era. <br/>
                                        • Dinner and overnight at hotel.



                                 </p>
                            </>
                        }
                        images={[  
                            TajMahal, 
                            AgraFort,


                            ]}
                        />


                         

                 <br/>

                 <hr className="mobile desktop" style={{ border: 'none', height: '1px', backgroundColor: '#e0e0e0', margin: '20px 0', }} />

                 <DaySlider
                        dayTitle="Day 05 : Agra - Fatehpur Sikri - Jaipur"
                        text={
                            <>
                                    <p>
                                             • 6hr drive by road (approx.) <br/>
                                            • UNESCO World Heritage site of Fatehpur Sikri  <br/>

                                            <hr style={{ border: 'none', height: '1px', backgroundColor: '#e0e0e0', margin: '20px 0', }} />

                                            • Breakfast at hotel. <br/>
                                            • Drive to the UNESCO World Heritage site of Fatehpur Sikri, the “City of Victory,” built by Emperor Akbar in the latter half of the 16th century. Though it served as the Mughal capital for only a decade, its monumental palaces, mosques, and temples stand as a testament to Akbar’s vision and the uniformity of Mughal architectural style. Wander through the ghostly corridors and expansive courtyards, imagining life in this short-lived imperial city. <br/>
                                            • Lunch enroute. <br/>
                                            • After lunch drive to Jaipur, the enthralling “Pink City” and capital of Rajasthan, famed for its distinctive rosy-hued buildings. Painted pink in 1876 to welcome the Prince of Wales and Queen Victoria, the color symbolizes hospitality, and Jaipur has since been celebrated as a city of warmth, tradition, and regal charm. The city is a tapestry of majestic forts, ornate palaces, bustling bazaars, and wide avenues, where Rajasthani culture comes alive in every corner. From the Hawa Mahal, with its intricate latticework and honeycomb windows, to the imposing City Palace, Jaipur showcases a perfect blend of heritage and vibrancy. <br/>
                                            • Dinner and overnight at hotel. 

                    
                                  </p>
                            </>
                        }
                        images={[  
                            FatehpurSikri, 
                            

                            ]}
                        />           
                 
            

                <br/>
                
                <hr className="mobile desktop" style={{ border: 'none', height: '1px', backgroundColor: '#e0e0e0', margin: '20px 0', }} />


                <DaySlider
                        dayTitle="Day 06 : Jaipur"
                        text={
                            <>
                                    <p> 
                                        • Old City Rickshaw tour with Pink City Rickshaw Company <br/>
                                        • Hawa Mahal, Jaipur’s most photographed building <br/>
                                        • Visit beautiful City Palace & Jantar Mantar <br/>
                                        • Afternoon Block printing workshop and shopping free time in local market or visit Gems and Jewelry boutique <br/>
                                        
                                        <hr style={{ border: 'none', height: '1px', backgroundColor: '#e0e0e0', margin: '20px 0', }} />

                                        • Breakfast at hotel. <br/>
                                        • After breakfast at the hotel, set out on an Old City Rickshaw tour with the Pink City Rickshaw Company, a women-led initiative offering an engaging 45–60 minute ride through Jaipur’s bustling lanes. Stop briefly at the iconic Hawa Mahal for photos before continuing to Govind Dev Ji Temple, where lively chants and devotional singing fill the air. Drive onward to the nearby flower market, its lanes bursting with marigolds, roses, and jasmine.  <br/>
                                        • These rickshaws will drop you at  Jantar Mantar, a UNESCO World Heritage site houses over 20 large instruments, designed to measure celestial positions with precision and innovation.
                                        • Walk across the road to visit the iconic City Palace, established alongside Jaipur itself by Maharaja Sawai Jai Singh II. Explore its courtyards, ceremonial halls, and intricate architecture, once the administrative heart of the Maharaja’s kingdom. Lunch at restaurant inside City Palace complex (lunch on direct payment). <br/>
                                            • Enjoy a hands-on Jaipur block printing workshop, learning heritage techniques, natural dyes, and creating your own design with artisans. Later, explore local markets or a gems boutique, witnessing Jaipur’s renowned gemstone cutting, polishing, and exquisite handcrafted jewelry in the city.
                                        <br/>

                                        • Dinner and overnight at hotel.
                    
                                 </p>
                            </>
                        }
                        images={[  
                            Jaipur1, 
                            

                            ]}
                        /> 


                <br/>

                <hr className="mobile desktop" style={{ border: 'none', height: '1px', backgroundColor: '#e0e0e0', margin: '20px 0', }} />

                <DaySlider
                        dayTitle="Day 07 : Jaipur"
                        text={
                            <>
                                     <p> 
                                            • Excursion to 16th century Amber Fort (using electric battery Golf cart) <br/>
                                            • Interactions with elephants at Dera Amer <br/>
                                            • Lunch at Dera Amer <br/>
                                            • Visit local family for Diwali celebration <br/>

                                            <hr style={{ border: 'none', height: '1px', backgroundColor: '#e0e0e0', margin: '20px 0', }} />


                                            • After breakfast, proceed to the majestic Amber Fort, built in the 16th century by Raja Man Singh. Explore its highlights—including the Sukh Mandir, Hall of Public Audience, shimmering Sheesh Mahal, and the terraced Kesar Kyari—while enjoying the fort’s calmer atmosphere later in the morning. <br/>

                                            • Continue to Dera Amer, a tranquil countryside retreat on Jaipur’s outskirts, set amid the Aravalli hills. Here, spend time with elephants that have been rescued and rehabilitated by the family-run estate, learning about their personalities, routines, and gentle nature through ethical, hands-on interaction.  <br/>

                                            • After this enriching experience, enjoy a relaxed lunch at the camp (included), return to the hotel to freshen up. <br/>

                                            • In the evening, visit a local family to celebrate Diwali, enjoying warm interaction, festivities, and dinner. <br/> 

                                            • Overnight at hotel.

                    
                                     </p> 

                                    <p> Note: We may have to change the sightseeing schedule of Jaipur because of Diwali festival. We will finalise it closer to the date of travel.</p>

                            </>
                        }
                        images={[  
                            Jaipur2, 
                            

                            ]}
                        />        

               
            
                <br/>
                                

                <hr className="mobile desktop" style={{ border: 'none', height: '1px', backgroundColor: '#e0e0e0', margin: '20px 0', }} />

                 <DaySlider
                        dayTitle=" Day 8 : Jaipur - Jodhpur "
                        text={
                            <>
                                      <p> 
                                            • 6hr drive by road (approx.) <br/>
                                            • Possibility to stop enroute at Pushkar to visit Holy lake & visit temple dedicated to Lord Brahma (will extend drive by 1h + visit time) <br/>
                                            • Bollywood dance class <br/>

                                            <hr style={{ border: 'none', height: '1px', backgroundColor: '#e0e0e0', margin: '20px 0', }} />


                                            • Breakfast at hotel. <br/>
                                            • Morning drive to Jodhpur, former seat of Marwar royalty, famed for its blue houses, vibrant ambience, and grand Rajput heritage. Founded by Rao Jodha, the city rose to prominence after the construction of the mighty Mehrangarh Fort. <br/>
                                            • Option : Stop enroute at Pushkar (it will increase the driving time)  <br/>
                                            • Lunch enroute. <br/>
                                            • On arrival in Jodhpur, stop at a dance studio for a lively Bollywood dance lesson. Learn a few energetic steps inspired by India’s iconic films, enjoy rhythmic beats, and have fun as an instructor guides the group through simple choreography—perfect for laughter, movement, and unforgettable memories. <br/>

                                            • Check-in at hotel.  <br/>
                                            • Dinner and overnight at hotel.
                   
                                     </p>
                            </>
                        }
                        images={[  
                            Pushkar1, Pushkar2, Pushkar3, 

                            ]}
                        /> 

           
            

                 <br/>

                <hr className="mobile desktop" style={{ border: 'none', height: '1px', backgroundColor: '#e0e0e0', margin: '20px 0', }} />

                 <DaySlider
                        dayTitle=" Day 9 : Jodhpur "
                        text={
                            <>
                                       <p> 
                                            • Meharangarh Fort  <br/>
                                            • Jaswant Thada. <br/>
                                            • Walking tour of Old City. <br/>
                                            • Visit an NGO working towards empowerment of women. Interact with them. <br/>

                                            <hr style={{ border: 'none', height: '1px', backgroundColor: '#e0e0e0', margin: '20px 0', }} />


                                            • Breakfast at hotel. <br/>

                                            • Morning visit the Meharangarh Fort, a huge and imposing structure, perched atop a hill and looking over the blue façade of the city. Elegant jharokhas and intricate lattice work makes this fort and palace a true masterpiece. <br/>

                                            • Continue to visit Jaswant Thada, a mausoleum and a memorial site for the members of a Rajput clan. It is a white marbled architectural marvel built by Maharaja Sardar Singh, the son of illustrious 33rd Rathore Ruler of Jodhpur, Jaswant Singh II. It is a fine example of brilliant architecture. When the rays of sun fall on its exterior, it glows like a diamond. The walls of the building are adorned with portraits and paintings. <br/>

                                            • Continue to the Sambhali Trust, where you will learn about their impactful community initiatives and meet some of the women and girls who benefit from the program. Enjoy a cooking demonstration and a delicious meal prepared by the women of the Trust. Your visit directly supports Sambhali’s ongoing efforts to empower women, girls, and gender minorities through education, vocational training, and sustainable development. <br/>

                                            • Later in the day, explore narrow lanes of old blue city with havelis, houses and gorgeous temples. End you walk at the Clock Tower of Jodhpur where you will find a spice market. <br/>
                                            • Dinner and overnight at hotel.

                   
                                 </p>
                            </>
                        }
                        images={[  
                        MehrangarhFort, JaswantThada, JodhpurOldCity
                            

                            ]}
                        /> 


               



                 <br/>

                <hr className="mobile desktop" style={{ border: 'none', height: '1px', backgroundColor: '#e0e0e0', margin: '20px 0', }} />


                <DaySlider
                        dayTitle=" Day 10 : Jodhpur - Ranakpur - Udaipur"
                        text={
                            <>
                                        <p> 

                                             • 6hr drive by road + visit time <br/>
                                            • Visit Jain temple in Ranakpur <br/>

                                            <hr style={{ border: 'none', height: '1px', backgroundColor: '#e0e0e0', margin: '20px 0', }} />


                                            • Breakfast at hotel. <br/>
                                            • Morning drive to the Ranakpur Jain Temple, one of India’s most exquisite and meticulously carved Jain temples, dedicated to Lord Adinath. Set in a quiet valley of the Aravalli hills, it is renowned for its stunning marble architecture, featuring 1,444 uniquely carved pillars—no two alike. The temple’s airy halls, delicate domes, and intricate sculptures create a serene, almost meditative atmosphere. Its harmonious design and extraordinary craftsmanship make it a remarkable example of 15th century Jain artistry and devotion. <br/>

                                            • Lunch at the local restaurant. <br/>
                                            
                                            • Drive further to Udaipur, the enchanting City of Lakes, where water and history meet in perfect harmony. Nestled at the foothills of the Aravalli Hills, the city is cradled by Lake Pichola, its serene waters reflecting palaces, temples, and historic havelis like jewels shimmering in the sun. Founded in the 16th century by Maharana Udai Singh II, Udaipur is a living canvas of Rajput heritage, where grandeur, culture, and timeless traditions blend seamlessly. <br/>
                                            
                                            • Arrive and check-in at hotel. <br/>

                                            • Dinner and overnight at hotel. <br/>

                   
                                         </p>
                            </>
                        }
                        images={[  
                            Udaipur1,
                    

                            ]}
                        /> 

              


                <br/>

                    <hr className="mobile desktop" style={{ border: 'none', height: '1px', backgroundColor: '#e0e0e0', margin: '20px 0', }} /> 

                <DaySlider
                        dayTitle=" Day 11 : Udaipur  "
                        text={
                            <>
                                        <p> • Visit City Palace <br/>
                                            • Sahlion ki bari <br/>
                                            • Painting boutique <br/>
                                            • Boat ride on Lake Pichola with view of City Palace and Lake Palace <br/>
                                           
                                            
                                            <hr style={{ border: 'none', height: '1px', backgroundColor: '#e0e0e0', margin: '20px 0', }} />
                                             • Breakfast at hotel. <br/>
                                            • Begin your day at Udaipur’s majestic City Palace Complex, a stunning fusion of Rajasthani and Mughal architecture. Explore its ornate halls decorated with mosaics, mirrors, and miniature paintings, each showcasing the legacy of the Mewar rulers. From the palace terraces, enjoy sweeping views of Lake Pichola and the city’s timeless beauty. <br/>
                                            • Drive to the enchanting Sahelion Ki Bari, the Garden of the Maids of Honor. Its marble pavilions, graceful fountains, and manicured lawns create a serene oasis where the whispers of history mingle with the gentle flow of water and the scent of vibrant flowers. <br/>
                                            • Stop at a painting boutique, where the delicate strokes of miniature paintings capture the soul of Rajasthan. Admire these intricate works of art and select souvenirs to carry home—a timeless piece of Udaipur’s beauty for yourself, family, or friends. <br/>
                                            • Lunch during the visit (Thali lunch, vegetarian food – included in the cost). <br/>
                                            • Enjoy a boat on Lake Pichola, and let the gentle waves carry you into the heart of the city’s romance. Pause at Jag Mandir Island, a marble gem adorned with elegant pillars, domes, and fountains, where the gardens whisper tales of royal leisure and artistic splendor. <br/>
                                            • Dinner at local restaurant (included in the cost). <br/>
                                            • Overnight at hotel. <br/>
                                      </p>
                            </>
                        }
                        images={[  
                            Udaipur2,  Udaipur3 , Udaipur4,
                            

                            ]}
                        /> 
           

                <br/>

                 <hr className="mobile desktop" style={{ border: 'none', height: '1px', backgroundColor: '#e0e0e0', margin: '20px 0', }} />



                 <DaySlider
                        dayTitle=" Day 12 : Departure transfer to Udaipur airport (end of services)  "
                        text={
                            <>
                                        <p> 
                                           • Breakfast at hotel. <br/>
                                           • Morning free to relax (option of yoga class or riding a bicycle around the lake side – at extra cost).    <br/>
                                            • Early lunch at the hotel (not included in our cost). <br/>
                                            • In time transfer to the airport to connect the flight to the next destination (if required, we can assist you in booking your flight to Delhi or other destinations within India at extra cost). <br/>
                                            • End of our services after departure transfer to Udaipur airport (if services are required in Delhi or other destinations after Udaipur, let us know to advise you the extra cost). <br/>


                                         </p>
                            </>
                        }
                        images={[  
                            DelhiFlight2,
                            

                            ]}
                        /> 

               


                <br/>

                 {/* <hr className="mobile desktop" style={{ border: 'none', height: '1px', backgroundColor: '#e0e0e0', margin: '20px 0', }} /> */}


                {/* <DaySlider
                        dayTitle=" Day 13 : Delhi / Fly back  "
                        text={
                            <>
                                      
                                        


                            </>
                        }
                        images={[  
                            //  DelhiFlight2

                            ]}
                        />  */}
                 
            <hr className="mobile desktop" style={{ border: 'none', height: '1px', backgroundColor: '#e0e0e0', margin: '20px 0', }} />

                
            </div>

            <br/> <br/>

             <div className='' id="important">

                <p className='  content-head'> Its Important to know that</p>
                <p className=''> 
                                        • In India, tipping is customary, and this local custom. To ensure our customers enjoy their trip to the full, we can include small tips in our prices: in all restaurants, for porters, tuk-tuk and rickshaw drivers, shoe guards, 4x4 drivers, ceremony officiants, etc. Let us know if you would like to include these into your cost. (Customers are free to tip their guide and driver as they see fit).  <br/>


                    • Indian traditions are diverse and very different from Western customs and practices. We kindly ask you to inform travellers of the need to respect local customs and practices (dress code in places of worship, calm and patience, etc.). <br/>


                    • Hotel rooms are available from 2.30/3 p.m. and must be vacated by noon. <br/>


                    • This programme is subject to change due to technical or local requirements, weather conditions and force majeure. In any case, any changes that may be made will be in the interest of travellers, with a view to quality, and to offer them equivalent alternatives.
                    <br/>

                    • Images are not contractually binding. The client travel agency assumes full responsibility for the use of the images presented in this document.


                </p>

                
            </div>

            <br/> <br/>


              <div className='' id="visa">

                <p className='  content-head'> Visa formalities & Disembarkation Card</p>
                <p className=''> 

                            <hr style={{ border: 'none', height: '1px', backgroundColor: '#e0e0e0', margin: '20px 0', }} />

                            Passport validity : 
                            Passport must be valid for six months beyond date of visa application to obtain a visa.
                            <br/>
                            <hr style={{ border: 'none', height: '1px', backgroundColor: '#e0e0e0', margin: '20px 0', }} />
                            Tourist visa required : 
                            To travel to India, you need a Visa. 
                            Travelers must enter either on a paper visa or an e-tourist visa.
                            <br/>
                            <hr style={{ border: 'none', height: '1px', backgroundColor: '#e0e0e0', margin: '20px 0', }} />

                            e-visa : 
                            To know the list of countries eligible for e-visa and to apply e-visa (e-tourist visa), please refer to official website: <br/>
                            https://indianvisaonline.gov.in/evisa/tvoa.html 
                            
                            <br/>
                            
                            e-visa fee: 
                                <a
                                    href="https://indianvisaonline.gov.in/evisa/images/Etourist_fee_final.pdf"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="visa-link"
                                    >
                                    Click Here
                                    </a>
                            <br/>
                            <hr style={{ border: 'none', height: '1px', backgroundColor: '#e0e0e0', margin: '20px 0', }} />
                            Disembarkation Card : Foreign travellers to India including OCI card holders needs fill the Disembarkation Card digitally up to 72 hours prior to arrival in India via the official Indian visa website  
                            https://indianvisaonline.gov.in/earrival/ <br/>
                            • “Indian Visa Su-Swagatam” mobile app <br/>
                            • Above is not required by Indian Nationals. <br/>
                            • Carry copy of the form submitted / acknowledgement. <br/>

                            <hr style={{ border: 'none', height: '1px', backgroundColor: '#e0e0e0', margin: '20px 0', }} />


                </p>

                
            </div>
            


            

            <br/> <br/>


              <div className='' id="hotels">

                <p className='  content-head'> Hotels Envisaged (Standard Room Category - Subject to Availability)  </p>
                

                <div className="hotel-table-wrapper">

                        <table className="hotel-table">
                            <thead>
                            <tr>
                                <th>City</th>
                                <th>Hotels</th>
                                <th>No of nights</th>
                            </tr>
                            </thead>

                            <tbody>
                            <tr>
                                <td>Delhi</td>
                                <td>
                                <a
                                    href="https://www.theleela.com/the-leela-ambience-convention-hotel-delhi"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    The Leela Ambience Convention Hotel Shahdara
                                </a>
                                </td>
                                <td>01</td>
                            </tr>

                            <tr>
                                <td>Agra</td>
                                <td>
                                <a
                                    href="https://www.hilton.com/en/hotels/agrdtgi-doubletree-agra/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    DoubleTree by Hilton Hotel
                                </a>
                                </td>
                                <td>02</td>
                            </tr>

                            <tr>
                                <td>Jaipur</td>
                                <td>
                                <a
                                    href="https://www.hotelbrijcastle.com/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    Hotel Brij Castle
                                </a>
                                </td>
                                <td>03</td>
                            </tr>

                            <tr>
                                <td>Jodhpur</td>
                                <td>
                                <a
                                    href="#"
                                    onClick={(e) => e.preventDefault()}
                                >
                                    Bungalow 2
                                </a>
                                </td>
                                <td>02</td>
                            </tr>

                            <tr>
                                <td>Udaipur</td>
                                <td>
                                <a
                                    href="https://www.hotelnaturallakeview.com/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    Hotel Natural Lake View
                                </a>
                                </td>
                                <td>02</td>
                            </tr>
                            </tbody>
                        </table>

                        </div>

                        <br/> 

                        <p className='content-head'>  Note: Total rooms booked for this departure are 7 rooms only. </p>

                            <hr style={{ border: 'none', height: '1px', backgroundColor: '#e0e0e0', margin: '20px 0', }} />

                        <p> 6 rooms will be with a large / queen bed which can be used as a double room by those who wish to share a room and bed with other person or as a single room by those who wish to travel alone and not looking forward to sharing the room with anyone. Those not sharing a room (needing a single room) will have to pay Single Room Supplement as an extra cost as mentioned in the rate mentioned below. </p>
                        <br/>
                        <p> Additionally, we have 1 room as twin room (room with 2 separate beds) for those who are willing to share the room but not the bed. Incase, we find more than 2 people interested in twin rooms, we will check the room availability before confirming the booking. </p>

                        <hr style={{ border: 'none', height: '1px', backgroundColor: '#e0e0e0', margin: '20px 0', }} />

            </div>
            
            <br/> <br/>

             <div className='' id="rates">

                <p className='  content-head'> Rates (per person)  </p>
                <p className=''> RATES in USD - NET non commission able </p>

                <p> Per person rates on twin sharing basis (2 people sharing 1 room) </p>

                <p className="rate-title"> (Rate validity from 2 Nov to 14 Nov 2026)                        </p>



                <div className="rate-table-wrapper">

                        
                        <table className="rate-table">
                            <thead>
                            <tr>
                                <th>Number of people</th>
                                <th>per person rate</th>
                            </tr>
                            </thead>

                            <tbody>
                            <tr>
                                <td>03 Paying Person traveling together</td>
                                <td>USD 3162 per person</td>
                            </tr>
                            <tr>
                                <td>04 Paying Person traveling together</td>
                                <td>USD 2832 per person</td>
                            </tr>
                            <tr>
                                <td>05 Paying Person traveling together</td>
                                <td>USD 2634 per person</td>
                            </tr>
                            <tr>
                                <td>06 Paying Person traveling together</td>
                                <td>USD 2502 per person</td>
                            </tr>
                            <tr>
                                <td>07 Paying Person traveling together</td>
                                <td>USD 2408 per person</td>
                            </tr>

                            <tr>
                                <td>
                                Single Room Supplement (to be paid additionally if someone
                                stays alone in a single room)
                                </td>
                                <td>USD 727 per Single Room</td>
                            </tr>

                            <tr>
                                <td>Supplement for Cycle tour in Udaipur</td>
                                <td>USD 26 Per Person</td>
                            </tr>

                            <tr>
                                <td>Supplement for Yoga Class in Udaipur</td>
                                <td>USD 26 Per Person</td>
                            </tr>

                            <tr>
                                <td>
                                Airfare Supplement in economy class for Udaipur / Delhi sector
                                (with 20 Kg baggage – 01 Piece) on 13 November 2026 + transfer
                                from airport to a local restaurant for Dinner and back to
                                airport using an AC Vehicle on 13 November 2026.
                                <br /><br />
                                Currently applicable airfare and subject to change at the time
                                of booking.
                                <br />
                                (Flight AI 1820 – 1400 / 1530 Hrs)
                                </td>
                                <td>USD 177 Per Person</td>
                            </tr>

                            <tr>
                                <td>
                                Supplement for Dinner at a local restaurant in Delhi on fixed
                                menu basis on 13 November 2026
                                </td>
                                <td>USD 26 Per Person</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>


                
                <br/>

              <p className="iti-head"> Our Rates Includes: </p>
                    <p>
                    • 10 Nights’ accommodation on twin sharing basis at the hotels mentioned above or similar hotels. <br/>
                    • Meals as per the programme: <br/>
                      -- 10 Breakfasts starting from Day 3 till Day 12. <br/>
                      -- 9 Dinners starting from Day 3 till Day 11. <br/>
                      -- 7 Lunches (03 Nov, 05 Nov, 07 Nov, 08 Nov, 09 Nov, 10 Nov and 11 Nov 2026). <br/>
                    • All meals will be provided on fixed menu basis. <br/>
                    • Elephant interaction in Jaipur on 08 November 2026. <br/>
                    • Rickshaw ride in Old Delhi (02 pax per rickshaw). <br/>
                    • Block printing workshop in Jaipur. <br/>
                    • Rickshaw ride through the pink city of Jaipur. <br/>
                    • Diwali celebrations with a local family in Jaipur. <br/>
                    • Bollywood dance class in Jodhpur. <br/>
                    • Boat ride on Lake Pichola in Udaipur (shared boat ride, subject to availability). <br/>
                    • Entrance fees (single entry) to visit all the monuments mentioned in the programme. <br/>
                    • English-speaking tour guide from Delhi to Delhi (guide does not stay in the same hotels). <br/>
                    • Transport services using Air-conditioned Urbania as per the program. <br/>
                    • Road taxes, parking fees, fuel costs, interstate taxes and service charges. <br/>
                    • Airport representative for assistance with arrival and departure transfers only. <br/>
                    • All applicable taxes currently in force (5% GST, subject to change). <br/>
                    </p>

                    <br/>
                    

                    <p className="iti-head"> Above Rates DOES NOT Include: </p>
                    <p>
                    • Stay in single occupancy. Please check single supplement. <br/>
                    • Accommodation in Delhi on Day 1 (02 to 03 Nov 2026) and Day 12 (13 to 14 Nov 2026). <br/>
                    • Expense of personal nature like laundry, table drinks, telephone calls, camera / video camera fee at monuments, medical expenses, etc. <br/>
                    • Tips for guide and driver. <br/>
                    • Any meal not mentioned above or in the program. <br/>
                    • Any meals on Day 2. <br/>
                    • Any insurance cover or airport taxes. <br/>
                    • Domestic airfare / flight ticket for Udaipur / Delhi (Supplement quoted separately). <br/>
                    • Any other services not mentioned in the inclusions. <br/>
                    • Indian Visa. <br/>
                    • Travel Insurance (we strongly recommend to buy travel insurance). <br/>
                    • International airfare / flight tickets. <br/>
                    • Any other services not mentioned above in cost includes section. <br/>
                    </p>




            </div>

            <br/> <br/>


               <div className='' id="payment">
                        
                <p className='  content-head'> Payment & Cancellation  </p>
                <br/>
                <p className=" iti-head"> Payment: </p>

                <p > Advance 20% at the time of booking.  <br/> Balance 80%, 60 days before arrival in India.  </p>

                <br/>
                <p className=" iti-head"> Cancellation Charges  </p>

                <p> 
                    D60 before the arrival date: Cancellation without charge, except for the cost of domestic flights, which are paid at the time of booking and subject to cancellation charge of 3500 INR per person. <br/>

                    D59 to D46 before the arrival date: 25% of the total package cost. <br/>
                    D45 to D31 before the arrival date: 50% of the total package cost. <br/>
                    D30 to D15 before the arrival date: 70% of the total package cost. <br/> 
                    D14 / No-Show: 100% of the total package cost.

                 </p>


            </div>
            
            <br/> <br/>


             <div className='' id="transport">

                <p className='  content-head'> Transport/ Vehicle envisaged for this Tour  </p>
                <p className=''> 

                    
                    <img src={Van2}  width='100%' alt="#" />
                    <img src={Van1} width="100%" alt="#" /> 
                     <img src={Van3} width="100%" alt="#" /> 

                    
                     </p>            

            </div>

            <br/> <br/>

            

            <div className='' id="climate">

                <p className='  content-head'> Climate in India  </p>
                <p className=''> 
                    India's climatic regions range from temperate in the north to subtropical in the center, with tropical monsoon regions in the south. The north is characterized by the foothills of the Himalayas. At high altitudes, there are snowfalls and alpine conditions in winter. Summers, on the other hand, are very hot, with temperatures reaching 50°C. The center and south of the country are hit by heavy rainfall from June to September. The high humidity creates a sticky, unpleasant climate. Due to the influence of the Indian Ocean, however, temperatures are lower, fluctuating between 25 and 35°C during the day, depending on the season. The rainy season starts around June and lasts until September/October.
                    
                     </p>   

                     <br/>


                      <img src={Climate1}  width='100%' alt="#" />         

                      <br/>


            </div>



             <br/> <br/>


     </div>
   






   </div>
   

    </>




  )
}

export default TimelessIndia



